module.exports = __webpack_public_path__ + "img/BRCA2_TMKI67.dd052f67.png";